<script lang="ts" setup>
const props = defineProps({
  paddingX: {
    type: String,
    required: false,
    default: '20px'
  },
  paddingY: {
    type: String,
    required: false,
    default: '16px'
  },
  backGroundColor: {
    type: String,
    required: false,
    default: '#FFFFFF'
  },
  bordered: {
    type: Boolean,
    required: false,
    default: true
  }
});

import { ref } from 'vue';
import useAuthStore from '@/stores/auth';

const cardRef = ref(null);
const authStore = useAuthStore();
</script>

<template>
  <div
    ref="cardRef"
    class="overflow-hidden shadow-xl bg-white dark:!bg-blue-dark-menus dark:text-[#E8F9FF] rounded-2xl"
    :style="{ 'background-color': `${props.backGroundColor}`, 'border': `1px solid ${bordered ? (authStore.isDark ? '#032F43' : '#EBEEFA') : 'transparent'}` }"
  >
    <div
      class="h-[100%]"
      :style="{ padding: `${props.paddingY} ${props.paddingX}` }"
    >
      <div class="font-bold text-xl">
        <slot name="header" />
      </div>
      <div class="relative">
        <slot />
      </div>
      <div>
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>
